import { ArrowRight, MessageCircle, ShieldCheck } from "lucide-react";
import { Button } from "../ui/button";
import { HERO_IMAGE, IMAGES, WHATSAPP_URL } from "../../lib/site-data";

export default function Hero() {
    return (
        <section className="relative overflow-hidden border-b border-white/5" data-testid="hero-section">
            {/* Background */}
            <div className="absolute inset-0">
                <img
                    src={IMAGES.heroBg}
                    alt=""
                    className="w-full h-full object-cover opacity-50"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black"></div>
                <div className="absolute inset-x-0 top-1/2 h-px laser-line"></div>
            </div>

            <div className="relative max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 pt-16 md:pt-24 lg:pt-28 pb-20 md:pb-28">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
                    <div className="lg:col-span-7 space-y-8 animate-slide-in">
                        <div className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-cyan-300/90">
                            <span className="inline-block w-8 h-px bg-cyan-300"></span>
                            Esenyurt / İstanbul
                        </div>

                        <div className="space-y-3">
                            <h1 className="font-display font-light text-5xl md:text-6xl lg:text-7xl tracking-tight text-white text-balance">
                                İstanbul <span className="text-cyan-300 glow-cyan">Dövme Silme</span>
                            </h1>
                            <p className="text-sm md:text-base uppercase tracking-[0.3em] text-zinc-400">
                                Doğuş Çizikoğlu
                            </p>
                        </div>

                        <h2 className="font-display text-2xl md:text-3xl text-zinc-100 max-w-2xl text-balance">
                            Pico Lazer Dövme Silme ve Fraksiyonel CO2 Lazer Uygulamaları
                        </h2>

                        <p className="text-base md:text-lg text-zinc-400 max-w-2xl leading-relaxed">
                            Dövme silme, cover-up öncesi dövme açtırma, faça izi, yanık izi, akne izi
                            ve cilt yüzeyindeki iz görünümünün azaltılmasına yönelik kişisel ön
                            değerlendirme ile size en uygun lazer süreci planlanır.
                        </p>

                        <div className="flex flex-col sm:flex-row gap-3">
                            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="hero-whatsapp-btn">
                                <Button
                                    size="lg"
                                    className="w-full sm:w-auto bg-cyan-400 text-black hover:bg-cyan-300 transition-all duration-300 shadow-[0_0_30px_rgba(0,240,255,0.3)] hover:shadow-[0_0_40px_rgba(0,240,255,0.5)] font-medium px-7 py-6"
                                >
                                    <MessageCircle className="h-5 w-5 mr-2" />
                                    WhatsApp'tan Fotoğraf Gönder
                                </Button>
                            </a>
                            <a href="#lead-form" data-testid="hero-form-btn">
                                <Button
                                    size="lg"
                                    variant="outline"
                                    className="w-full sm:w-auto bg-transparent border-white/20 text-white hover:bg-white/5 hover:border-white/40 font-medium px-7 py-6"
                                >
                                    Ücretsiz Ön Değerlendirme Formu
                                    <ArrowRight className="h-4 w-4 ml-2" />
                                </Button>
                            </a>
                        </div>

                        <div className="flex items-start gap-2 text-xs text-zinc-500 pt-2 max-w-2xl">
                            <ShieldCheck className="h-4 w-4 mt-0.5 text-zinc-500 flex-shrink-0" />
                            <p className="leading-relaxed">
                                Sonuçlar kişiden kişiye değişebilir. Net seans sayısı ve uygunluk,
                                cilt yapısı ve dövme/iz analizi sonrası belirlenir.
                            </p>
                        </div>
                    </div>

                    {/* Device image */}
                    <div className="lg:col-span-5 relative animate-slide-in">
                        <div className="relative rounded-2xl overflow-hidden border border-white/10 bg-gradient-to-br from-zinc-900/80 to-black/80 backdrop-blur-xl">
                            <div className="absolute -top-20 -right-20 w-60 h-60 bg-cyan-400/20 blur-[80px] rounded-full pointer-events-none"></div>
                            <img
                                src={HERO_IMAGE}
                                alt="Pico lazer cihazı"
                                className="relative w-full h-auto object-cover"
                            />
                            <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black to-transparent"></div>
                            <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
                                <div>
                                    <p className="text-[10px] uppercase tracking-[0.3em] text-cyan-300/80">
                                        Klinik Cihaz
                                    </p>
                                    <p className="text-sm text-white font-medium">
                                        Pico Lazer Sistemi
                                    </p>
                                </div>
                                <div className="text-right">
                                    <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                                        Wavelength
                                    </p>
                                    <p className="text-xs text-cyan-300 font-mono">1064nm / 532nm</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
